import { ImageIcon } from "lucide-react";

/**
 * Styled placeholder so real images / videos can be dropped in later.
 * Pass `label` to describe the intended asset.
 */
export const ImagePlaceholder = ({
  label = "Image",
  icon: Icon = ImageIcon,
  className = "",
  ratio = "aspect-[4/3]",
  rounded = "rounded-2xl",
}) => {
  return (
    <div
      data-testid="image-placeholder"
      className={`vc-placeholder relative flex ${ratio} w-full items-center justify-center overflow-hidden border border-[hsl(var(--vc-line))] ${rounded} ${className}`}
    >
      <div className="flex flex-col items-center gap-2 px-4 text-center">
        <span className="grid h-11 w-11 place-items-center rounded-full bg-white/80 text-brand vc-shadow-soft">
          <Icon className="h-5 w-5" />
        </span>
        <span className="text-xs font-semibold uppercase tracking-[0.16em] text-[hsl(var(--vc-slate))]">
          {label}
        </span>
      </div>
      <span className="absolute right-2 top-2 rounded-full bg-white/70 px-2 py-0.5 text-[0.6rem] font-medium text-[hsl(var(--vc-slate))]">
        placeholder
      </span>
    </div>
  );
};

export default ImagePlaceholder;
